import { render, staticRenderFns } from "./Model6.vue?vue&type=template&id=76fd7be4&scoped=true&"
import script from "./Model6.vue?vue&type=script&lang=js&"
export * from "./Model6.vue?vue&type=script&lang=js&"
import style0 from "./Model6.vue?vue&type=style&index=0&id=76fd7be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fd7be4",
  null
  
)

export default component.exports